import { render, staticRenderFns } from "./ReorderCTABlock.vue?vue&type=template&id=04451dfe&"
import script from "./ReorderCTABlock.vue?vue&type=script&lang=js&"
export * from "./ReorderCTABlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports